// import React from 'react';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { smartGovernanceOff, smartGovernanceOn } from 'kosmos/images';

const PREFIX = '_smartGovernanceVerificationLogo';

const classes = {
  column: `${PREFIX}-column`,
  icon: `${PREFIX}-icon`,
};

const Root = styled('div')(() => ({
  position: 'relative',
  width: 235,
  display: 'flex',
  [`& .${classes.column}`]: {
    flex: 1,
    paddingLeft: 3,
    paddingRight: 3,
  },
  [`& .${classes.icon}`]: {
    border: '1px solid #3543d0',
    borderRadius: 4,
    width: '100%',
    padding: 3,
  },
  [`&.inactive .${classes.icon}`]: {
    border: '1px solid #949494',
    borderRadius: 4,
    width: '100%',
    padding: 3,
  },
  ['&.inactive h6']: {
    color: '#949494',
  },
}));

interface IProps {
  active: boolean;
  align: 'left' | 'right';
}

export default function SmartGovernanceVerificationLogo(props: IProps): JSX.Element {
  const { active, align } = props;
  const renderIcon = () => {
    const src = active ? smartGovernanceOn : smartGovernanceOff;
    return <img src={src} className={classes.icon} />;
  };

  const renderText = () => {
    const style = {
      marginTop: 5,
      textAlign: align,
    };
    return (
      <div style={style}>
        <Typography variant="h6" color="secondary" sx={{ fontWeight: 'bold', lineHeight: 1.1 }}>
          SMART
        </Typography>
        <Typography variant="h6" color="secondary" sx={{ fontWeight: 'bold', lineHeight: 1.1 }}>
          GOVERNANCE
        </Typography>
        <Typography variant="h6" sx={{ fontWeight: 'bold', lineHeight: 1.1 }}>
          {active ? 'VERIFIED' : 'NOT STARTED'}
        </Typography>
      </div>
    );
  };

  if (align === 'right') {
    return (
      <Root className={active ? 'active' : 'inactive'}>
        <div className={classes.column}>{renderText()}</div>
        <div className={classes.column}>{renderIcon()}</div>
      </Root>
    );
  } else {
    return (
      <Root>
        <div className={classes.column}>{renderIcon()}</div>
        <div className={classes.column}>{renderText()}</div>
      </Root>
    );
  }
}
